<template>
  <div>
    <svg ref="chart"></svg>
  </div>
</template>

<script>
  /* eslint-disable */
  import d3 from 'd3'
  import nv from 'nvd3'
  import $ from 'jquery'
  
  export default{
    props:{
      options: {
        type: Object,
        required: true
      },
      data: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        default: {
          options:{
            showLegend: true,
            donut: false,
            x: function(d) { return d.x },
            y: function(d) { return d.y },
            showTooltipPercent: false,
            labelsOutside: false
          }
        },
        chart: null
      }
    },
    mounted () {
      this.setChartOptions()
    },
    methods: {
      setChartOptions () {
        let options = {}, xAxis = {}, yAxis = {}
        if (this.options && this.options['chart']) {
          options = Object.clone(this.options['chart'])
          delete options.xAxis
          delete options.yAxis
          if (this.options['chart'] && this.options['chart']['xAxis']){
            xAxis = Object.clone(this.options['chart']['xAxis'])
          }
          if  (this.options['chart'] && this.options['chart']['yAxis']) {
            yAxis = Object.clone(this.options['chart']['yAxis'])
          }
        }
        const chartOptions = {
          options: Object.assign({}, this.default.options, options),
          xAxis: Object.assign({}, this.default.xAxis, xAxis),
          yAxis: Object.assign({}, this.default.yAxis, yAxis)
        }
  
        nv.addGraph(() => {
          const chart = nv.models.pieChart()
            .options(Object.assign({},{
              duration: 300
            }, chartOptions.options))
    
          $(this.$refs.chart).height(chartOptions.options.height || 300)
          
          if (chartOptions.xAxis) {
            Object.forEach(chartOptions.xAxis, (val, key) => {
              if (val) {
                chart.xAxis[key].call(this, val)
              }
            })
          }
          if (chartOptions.yAxis) {
            Object.forEach(chartOptions.yAxis, (val, key) => {
              if (val) {
                chart.yAxis[key].call(this,val)
              }
            })
          }
          
          this.drawChart(chart)
          this.chart = chart
          return chart
        });
      },
      drawChart (chart) {
        d3.select(this.$refs.chart)
          .datum(this.data)
          .transition()
          .call(chart)
        nv.utils.windowResize(chart.update);
      }
    },
    watch: {
      data: {
        handler: function () {
          if (this.chart) {
            this.drawChart(this.chart)
          }
        }
      },
      options: {
        handler: function (newVal) {
          if (this.chart) {
            this.setChartOptions()
            this.drawChart(this.chart)
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang='scss' scoped rel="stylesheet/scss">
</style>



// WEBPACK FOOTER //
// nvd3-pie-chart.vue?7f08b527